export default __webpack_public_path__ + "static/media/Curve2.eec252e4.svg";